export const AudienceIds = {
  /** Ninetailed audience ID for existing customer  */
  EC_AUDIENCE_ID: '2jMKO2QMpbfAnyQ2strEtw',
  /** Ninetailed audience ID for new customer  */
  NC_AUDIENCE_ID: '2cYqL4coJKzk99J1MrVzdn',
  /**
   * Ninetailed audience ID for existing customer in production
   * This ID is used to filter out production EC ID
   * so that we can apply control experience For EC customer experience,
   * @see : https://petsdeli.atlassian.net/browse/PT-7243
   * */
  PRODUCTION_EC_AUDIENCE_ID: '3MMJCDZVnbTQMiHy0VzSyz',
} as const;

export type AudienceIds = (typeof AudienceIds)[keyof typeof AudienceIds];
